import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "emailer-message" */ './EmailerMessage'));
